<template>
    <div class="box" v-loading="loading">
        <div class="park" v-if="showflag">
            <frist-step :choose-ids="chooseIds" :init-choose-ids="initChooseId" @changeProject="changeProject" ref="fristStep"/>
            <div class="footer">
                <el-button class="btnNew btnSize btn" @click="nextStep">下一步</el-button>
            </div>
        </div>
        <div class="merchantUpt" v-if="(!showflag || isRegister) && !loading">
            <div class="orderStep" v-if="!isRegister">
                <div class="box-content">
                    <div class="box-item" v-for="(item,index) in stepArr" :key="index">
                        <div class="flag flag-left" v-if="index"></div>
                        <div class="center-box" :class="{'has':index < active,'current':index === active}">
                            <div class="step-index step-num">{{index + 1}}</div>
                            <i class="step-num icon el-icon-check"></i>
                            <div class="step-text">{{item.text}}</div>
                        </div>
                        <div class="flag flag-right" v-if="index !== (stepArr.length - 1)"></div>
                    </div>
                </div>
            </div>
            <div class="title">
                <i class="iconfont icon-fillinformation_shopinfo font_style" style="display: inline-block;"></i>
                服务商信息
            </div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <div style="background-color: #fff; border-radius: 4px;margin-bottom:20px">
                    <div class="tabbox">
                        <el-tabs class="tabs" style="padding-left:10px" v-model="editableTabsValue" :closable="closable" @edit="handleTabsEdit">
                            <template v-for="(item, index) in ruleForm.shopList">
                            <el-tab-pane
                                v-if="item"
                                :key="index"
                                :label="item.parkName"
                                :name="index+''"
                            >
                                <div style="padding:0 100px;padding-bottom:20px" :key="index">
                                    <el-row>
                                        <el-col :span="12" style="height:35px">
                                                <el-form-item label="服务商类别" label-width="250px" prop="">
                                                    <div>企业服务商</div>
                                                </el-form-item>
                                        </el-col>
                                    </el-row>   
                                    <el-row class="newRow">
                                        <el-col :span="12" class="newCol">
                                                <el-form-item label="服务商店铺名称" :prop="`shopList[${index}].shopName`" label-width="250px" :rules="rules.shopList.shopName">
                                                    <el-input v-model="ruleForm.shopList[index].shopName" @keyup.native="ruleForm.shopList[index].shopName=ruleForm.shopList[index].shopName.replace(/\s+/g,'')" v-if="!showUpt" maxlength="100"></el-input>
                                                    <span class="showspan" v-if="showUpt">{{ruleForm.shopList[index].shopName}}</span>
                                                </el-form-item>
                                        </el-col>
                                        <el-col :span="12" class="newCol">
                                                <el-form-item label="服务商店铺电话" :prop="`shopList[${index}].contantMobile`" label-width="250px" :rules="rules.shopList.contantMobile">
                                                    <el-input v-model="ruleForm.shopList[index].contantMobile" @keyup.native="ruleForm.shopList[index].contantMobile=ruleForm.shopList[index].contantMobile.replace(/\s+/g,'')" v-if="!showUpt"></el-input>
                                                    <span class="showspan" v-if="showUpt">{{ruleForm.shopList[index].contantMobile}}</span>
                                                </el-form-item>
                                        </el-col>
                                        <el-col :span="12" class="newCol">
                                                <el-form-item label="服务商店铺地址" :prop="`shopList[${index}].shopAddress`" label-width="250px" :rules="rules.shopList.shopAddress">
                                                    <el-input v-model="ruleForm.shopList[index].shopAddress" @keyup.native="ruleForm.shopList[index].shopAddress=ruleForm.shopList[index].shopAddress.replace(/\s+/g,'')" v-if="!showUpt" maxlength="100"></el-input>
                                                    <span class="showspan" v-if="showUpt">{{ruleForm.shopList[index].shopAddress}}</span>
                                                </el-form-item>
                                        </el-col>
                                        <el-col :span="12" class="newCol">
                                                <el-form-item label="服务商店铺负责人身份证号" label-width="250px" :prop="`shopList[${index}].managerIdentityNo`" :rules="rules.shopList.managerIdentityNo">
                                                    <el-input v-model="ruleForm.shopList[index].managerIdentityNo" @keyup.native="ruleForm.shopList[index].managerIdentityNo=ruleForm.shopList[index].managerIdentityNo.replace(/\s+/g,'')" v-if="!showUpt"></el-input>
                                                    <span class="showspan" v-if="showUpt">{{ruleForm.shopList[index].managerIdentityNo}}</span>
                                                </el-form-item>
                                        </el-col>
                                        <el-col :span="12" class="newCol">
                                                <el-form-item label="服务商店铺负责人身份证正面照" label-width="250px" :prop="`shopList[${index}].managerIdentityAccessory`" :rules="rules.shopList.managerIdentityAccessory">
                                                    <el-upload
                                                        v-if="!showUpt"
                                                        :limit="1"
                                                        :file-list="ruleForm.shopList[index].managerIdentityAccessoryList"
                                                        list-type="picture-card"
                                                        name="uploadFile"
                                                        :action="UpImgUri"
                                                        :headers="myHeaders"
                                                        :class="{'hideUpload1': ruleForm.shopList[index].managerIdentityAccessoryList.length > 0}"
                                                        :on-success="(res,file)=>{return handleHeadSuccess(res, file, 'managerIdentityAccessoryList', index)}"
                                                        :on-remove="(file, fileList)=>{return handleHeadRemove(file, fileList, 'managerIdentityAccessoryList', index)}"
                                                        :before-upload="beforeAvatarUpload"
                                                        :on-preview="(file)=>{return handlePictureCardPreview(file,1)}"
                                                    >
                                                        <i class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-dialog :visible.sync="dialogVisible1">
                                                        <img width="100%" :src="dialogImageUrl1" alt="">
                                                    </el-dialog>
                                                    <p class="picture" @click="addpicture((ruleForm.shopList[index].managerIdentityAccessoryList[0] || {}).url)" v-if="showUpt">
                                                        <template v-if="(ruleForm.shopList[index].managerIdentityAccessoryList[0] || []).url">
                                                            <img :src="(ruleForm.shopList[index].managerIdentityAccessoryList[0] || {}).url" alt="#">
                                                            <span class="zzc"></span>
                                                        </template>
                                                    </p>
                                                </el-form-item>
                                        </el-col>
                                        <el-col :span="12" class="newCol">
                                                <el-form-item label="服务商店铺负责人身份证反面照" label-width="250px" :prop="`shopList[${index}].managerIdentityAccessoryBack`" :rules="rules.shopList.managerIdentityAccessoryBack">
                                                    <el-upload
                                                        v-if="!showUpt"
                                                        :limit="1"
                                                        :file-list="ruleForm.shopList[index].managerIdentityAccessoryBackList"
                                                        list-type="picture-card"
                                                        name="uploadFile"
                                                        :action="UpImgUri"
                                                        :headers="myHeaders"
                                                        :class="{'hideUpload2': ruleForm.shopList[index].managerIdentityAccessoryBackList.length > 0}"
                                                        :on-success="(res,file)=>{return handleHeadSuccess(res,file, 'managerIdentityAccessoryBackList', index)}"
                                                        :on-remove="(file, fileList)=>{return handleHeadRemove(file, fileList, 'managerIdentityAccessoryBackList', index)}"
                                                        :before-upload="beforeAvatarUpload"
                                                        :on-preview="(file)=>{return handlePictureCardPreview(file,2)}"
                                                    >
                                                        <i class="el-icon-plus"></i>
                                                    </el-upload>
                                                    <el-dialog :visible.sync="dialogVisible2">
                                                        <img width="100%" :src="dialogImageUrl2" alt="">
                                                    </el-dialog>
                                                    <p class="picture" @click="addpicture((ruleForm.shopList[index].managerIdentityAccessoryBackList[0] || {}).url)" v-if="showUpt">
                                                        <template v-if="(ruleForm.shopList[index].managerIdentityAccessoryBackList[0] || []).url">
                                                            <img :src="(ruleForm.shopList[index].managerIdentityAccessoryBackList[0] || {}).url" alt="#">
                                                            <span class="zzc"></span>
                                                        </template>
                                                    </p>
                                                </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-tab-pane>
                            </template>
                        </el-tabs>
                        <div id="addicon" @click="gopark"  v-show="checkStatus==1?false:true">
                            <img src="../../../assets/img/icon/addicon.png" alt="">
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i class="iconfont icon-fillinformation_enterpriseInformation font_style" style="display: inline-block;"></i>
                        服务商信息
                    </div>
                    <div style="background-color: #fff; border-radius: 4px;margin-bottom:20px;padding-top:20px">
                        <div style="padding:0 100px;padding-bottom:20px"> 
                        <el-row style="margin-top:15px;">
                            <el-col :span="12">
                                    <el-form-item label="服务商名称" prop="Q_name" label-width="250px">
                                        <el-input v-model="ruleForm.Q_name" @keyup.native="ruleForm.Q_name=ruleForm.Q_name.replace(/\s+/g,'')" v-if="!showUpt" maxlength="100"></el-input>
                                        <span v-if="showUpt">{{ruleForm.Q_name}}</span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="服务商电话" prop="Q_phone" label-width="250px">
                                        <el-input v-model="ruleForm.Q_phone" @keyup.native="ruleForm.Q_phone=ruleForm.Q_phone.replace(/\s+/g,'')" v-if="!showUpt"></el-input>
                                        <span v-if="showUpt">{{ruleForm.Q_phone}}</span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="社会信用代码" prop="Q_code" label-width="250px">
                                        <el-input v-model="ruleForm.Q_code" @keyup.native="ruleForm.Q_code=ruleForm.Q_code.replace(/\s+/g,'')" v-if="!showUpt"></el-input>
                                        <span v-if="showUpt">{{ruleForm.Q_code}}</span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="服务商地址" prop="Q_site" label-width="250px">
                                        <el-input v-model="ruleForm.Q_site" @keyup.native="ruleForm.Q_site=ruleForm.Q_site.replace(/\s+/g,'')" v-if="!showUpt" maxlength="100"></el-input>
                                        <span v-if="showUpt">{{ruleForm.Q_site}}</span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="营业执照" label-width="250px" prop="Q_licenseimg">
                                        <el-upload
                                            v-if="!showUpt"
                                            :limit="1"
                                            :file-list="fileList3"
                                            list-type="picture-card"
                                            name="uploadFile"
                                            :action="UpImgUri"
                                            :headers="myHeaders"
                                            :class="{hideUpload3:hideUpload3}"
                                            :on-success="(res,file)=>{return handleHeadSuccess(res, file, 3)}"
                                            :on-remove="(file, fileList)=>{return handleHeadRemove(file, fileList,3)}"
                                            :before-upload="beforeAvatarUpload"
                                            :on-preview="(file)=>{return handlePictureCardPreview(file,3)}"
                                        >
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                        <el-dialog :visible.sync="dialogVisible3">
                                            <img width="100%" :src="dialogImageUrl3" alt="">
                                        </el-dialog>
                                        <p class="picture" @click="addpicture(ruleForm.Q_licenseimg)" v-if="showUpt">
                                            <img :src="ruleForm.Q_licenseimg" alt="#">
                                            <span class="zzc"></span>
                                        </p>
                                    </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    </div>
                </div>
                <div>
                    <div class="title">
                        <i style="display: inline-block;">
                            <img src="../../../assets/img/icon/openbank.png" alt="#">
                        </i>
                        开户行信息
                    </div>
                    <div style="background-color: #fff; border-radius: 4px;margin-bottom:20px;padding-top:20px">
                        <div style="padding:0 100px;padding-bottom:20px"> 
                        <el-row style="margin-top:15px;">
                            <el-col :span="12" style="height:35px">
                                    <el-form-item label="银行账户类型" label-width="250px">
                                        <div>对公账户</div>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="银行名称" prop="bankName" label-width="250px">
                                        <el-input v-model="ruleForm.bankName" @keyup.native="ruleForm.bankName=ruleForm.bankName.replace(/\s+/g,'')" v-if="!showUpt" maxlength="100"></el-input>
                                        <span v-if="showUpt">{{ruleForm.bankName}}</span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="开户行所在地区" prop="K_site" label-width="250px">
                                        <el-cascader
                                        v-if="!showUpt"
                                        v-model="ruleForm.K_site"
                                        :options="provinces"
                                        @change="handleChange"
                                        >
                                        </el-cascader>
                                        <span v-if="showUpt">{{ruleForm.K_site[0] + '' + ruleForm.K_site[1]}}</span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="开户行名称" prop="K_name" label-width="250px">
                                        <el-input v-model="ruleForm.K_name" @keyup.native="ruleForm.K_name=ruleForm.K_name.replace(/\s+/g,'')" v-if="!showUpt" maxlength="100"></el-input>
                                        <span v-if="showUpt">{{ruleForm.K_name}}</span>
                                    </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                    <el-form-item label="对公账号" prop="K_number" label-width="250px">
                                        <el-input v-model="ruleForm.K_number" @keyup.native="ruleForm.K_number=ruleForm.K_number.replace(/\s+/g,'')" v-if="!showUpt"></el-input>
                                        <span v-if="showUpt">{{ruleForm.K_number}}</span>
                                    </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    </div>
                </div>
                <div style="margin-bottom:50px;">
                    <div class="title">
                        <i class="iconfont icon-fillinformation_legalperson font_style" style="display: inline-block;"></i>
                        法人信息
                    </div>
                    <div style="background-color: #fff; border-radius: 4px;margin-bottom:20px;padding-top:20px">
                        <div style="padding:0 100px;padding-bottom:20px"> 
                            <el-row style="margin-top:15px;">
                                <el-col :span="12">
                                        <el-form-item label="法人姓名" prop="F_name" label-width="250px">
                                            <el-input v-model="ruleForm.F_name" @keyup.native="ruleForm.F_name=ruleForm.F_name.replace(/\s+/g,'')" v-if="!showUpt" maxlength="50"></el-input>
                                            <span v-if="showUpt">{{ruleForm.F_name}}</span>
                                        </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                        <el-form-item label="法人手机号码" prop="F_phone" label-width="250px">
                                            <el-input v-model="ruleForm.F_phone" @keyup.native="ruleForm.F_phone=ruleForm.F_phone.replace(/\s+/g,'')" v-if="!showUpt"></el-input>
                                            <span v-if="showUpt">{{ruleForm.F_phone}}</span>
                                        </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                        <el-form-item label="法人身份证号" prop="F_idcard" label-width="250px">
                                            <el-input v-model="ruleForm.F_idcard" @keyup.native="ruleForm.F_idcard=ruleForm.F_idcard.replace(/\s+/g,'')" v-if="!showUpt"></el-input>
                                            <span v-if="showUpt">{{ruleForm.F_idcard}}</span>
                                        </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="法人身份证正面照" label-width="250px" prop="F_minimg1">
                                        <el-upload
                                        v-if="!showUpt"
                                        :limit="1"
                                        :file-list="fileList4"
                                        list-type="picture-card"
                                        name="uploadFile"
                                        :action="UpImgUri"
                                        :headers="myHeaders"
                                        :class="{hideUpload4:hideUpload4}"
                                        :on-success="(res,file)=>{return handleHeadSuccess(res,file,4)}"
                                        :on-remove="(file, fileList)=>{return handleHeadRemove(file, fileList,4)}"
                                        :before-upload="beforeAvatarUpload"
                                        :on-preview="(file)=>{return handlePictureCardPreview(file,4)}"
                                        >
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                        <el-dialog :visible.sync="dialogVisible4">
                                            <img width="100%" :src="dialogImageUrl4" alt="#">
                                        </el-dialog>
                                        <p class="picture" @click="addpicture(ruleForm.F_minimg1)" v-if="showUpt">
                                            <img :src="ruleForm.F_minimg1" alt="#">
                                            <span class="zzc"></span>
                                        </p>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="法人身份证反面照" label-width="250px" prop="F_minimg2">
                                        <el-upload
                                        v-if="!showUpt"
                                        :limit="1"
                                        :file-list="fileList5"
                                        list-type="picture-card"
                                        name="uploadFile"
                                        :action="UpImgUri"
                                        :headers="myHeaders"
                                        :class="{hideUpload5:hideUpload5}"
                                        :on-success="(res,file)=>{return handleHeadSuccess(res,file,5)}"
                                        :on-remove="(file, fileList)=>{return handleHeadRemove(file, fileList,5)}"
                                        :before-upload="beforeAvatarUpload"
                                        :on-preview="(file)=>{return handlePictureCardPreview(file,5)}"
                                        
                                        >
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                        <el-dialog :visible.sync="dialogVisible5">
                                            <img width="100%" :src="dialogImageUrl5" alt="">
                                        </el-dialog>
                                        <p class="picture" @click="addpicture(ruleForm.F_minimg2)" v-if="showUpt">
                                            <img :src="ruleForm.F_minimg2" alt="#">
                                            <span class="zzc"></span>
                                        </p>
                                    </el-form-item>
                                </el-col>
                            </el-row>   
                        </div>
                    </div>
                </div>
            </el-form>
            <div>
                <el-dialog 
                            title="提示"
                            :visible.sync="newAddUserMode"
                            width="420px" height="366px"
                            class="delClass"
                            center
                        >
                            <div style="padding:0 21%;text-align:center">
                                <span>确定删除该园区吗？</span>
                            </div>
                            <div slot="footer" class="dialog-footer">
                                <el-button class='closeBtn' style="width:100px" @click="btnno">取 消</el-button>
                                <el-button class="btnNew" @click="btnyes">确 定</el-button>
                            </div>
                        </el-dialog>

            </div>
            <!-- 图片放大 -->
            <div class="bigpicture" style="z-index:2000;background:rgba(0,0,0,0.5)" v-if="showpicture" @click="xiaoshi">
                <div class="picturebox" ref="picturebox"  @click.stop="">
                    <img :src="src" alt="#">
                </div>
            </div>
            <div class="footer" v-if="!isRegister" v-show="checkStatus==1?false:true">
                <el-button class="btnNew btnSize btn" @click="resetForm">上一步</el-button>
                <el-button class="btnNew btnSize btn" @click="submitForm">下一步</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/fetch/api'
import { GetInfo } from '@/fetch/com'
let token = GetInfo("token");
let UpImgUri = API.constantString();
import { isFunction } from '@/libs/utils/dataType'
import provinceCity from './citys.json'
import * as access from "@/config/access";
import fristStep from '@/components/fristStep';
import { checkStatus } from '@/common/util/constans' 
export default {
    components: {
        fristStep
    },
    props: ['isRegister'],
    data(){
        //电话
        var checkPhone = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('电话号码不能为空'));
            } else {
            const reg = /(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3578]\d{9})$)|(^(400)-(\d{3})-(\d{4})(.)(\d{1,4})$)|(^(400)-(\d{3})-(\d{4}$))|(^(400)(\d{3})(\d{4}$))|(^(400[0-9])-(\d{3})-(\d{3}$))/
            if (reg.test(value)) {
                callback();
            } else {
                return callback(new Error('请输入正确的电话号码'));
            }
            }
        };
        //身份证号码
        var id_Card = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('身份证号码不能为空'));
            } else {
            const reg = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
            if (reg.test(value)) {
                callback();
            } else {
                return callback(new Error('请输入正确的身份证号码'));
            }
            }
        };
        //银行卡号
        var bank_Card = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('对公账号不能为空'));
            } else {
            const reg = /^([1-9]{1})(\d{15}|\d{18})$/;
            if (reg.test(value)) {
                callback();
            } else {
                return callback(new Error('请输入正确的对公账号'));
            }
            }
        };
        //社会信用代码
        var social_Code = (rule, value, callback) => {
            if (!value) {
            return callback(new Error('社会信用代码不能为空'));
            } else {
            const reg =/[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
            if (reg.test(value)) {
                callback();
            } else {
                return callback(new Error('请输入正确的社会信用代码'));
            }
            }
        };
        return {
            dialogVisible1:false,
            dialogImageUrl1:'',
            dialogVisible2:false,
            dialogImageUrl2:'',
            dialogVisible3:false,
            dialogImageUrl3:'',
            dialogVisible4:false,
            dialogImageUrl4:'',
            dialogVisible5:false,
            dialogImageUrl5:'',
            closable:true,
            showUpt:false,
            showflag: false,
            src:'',
            initChooseId:[],//穿默认的初始id
            chooseIds: [],
            initParkList: [],   //初始园区数据
            initShopList: [],   //初始门店数据
            showpicture:false,
            checkStatus:access.session('checkStatus'),
            newAddUserMode:false,
            targetName:'',
            newparkList:[],
            active:1,
            stepArr:[
                {text:'选择入住园区'},{text:'填写店铺及服务商资料'},{text:'等待审核'}
            ],
            provinces:[],
            UpImgUri,
            myHeaders: {
                Authorization: 'Bearer ' + token
            },
            hideUpload1:false,
            hideUpload2:false,
            hideUpload3:false,
            hideUpload4:false,
            hideUpload5:false,
            fileList3:[],
            fileList4:[],
            fileList5:[],
            editableTabsValue:'0',
            ruleForm: {
                Q_name:'', //企业名称
                Q_phone:'', //企业电话
                Q_code:'', //企业社会信用代码
                Q_site:'', //企业地址
                Q_licenseimg:'', //企业营业执照
                K_site:[],
                K_name:'', //开户行名称
                bankName:'',//银行名称
                K_number:'', //对公账号
                F_name:'', //法人姓名
                F_phone:'', //法人电话
                F_idcard:'', //法人身份证号码
                F_minimg1:'', //法人身份证正面
                F_minimg2:'', //法人身份证反面
                shopList:[],
                parkList:[],
                managerIdentityAccessory:[],
                managerIdentityAccessoryBack:[]
            },
            rules: {
                shopName: [
                    {required: true, message: '请输入', trigger: 'blur'},
                ],
                shopList:{
                    parkId: [
                        {required: true, message: '请输入', trigger: 'blur'},
                    ],
                    businessType: [
                        {required: true, message: '请输入', trigger: 'blur'},
                    ],
                    shopName: [
                        {required: true, message: '请输入店铺名称', trigger: 'blur'},
                    ],
                    contantMobile: [
                        { required: true,validator: checkPhone, trigger: 'blur' },
                    ],
                    shopAddress: [
                        { required: true, message: '请输入店铺地址', trigger: 'blur' },
                    ],
                    managerIdentityNo: [
                        { required: true,validator: id_Card, trigger: 'blur' },
                    ],
                    managerIdentityAccessory: [
                        {required: false, message: '请上传店铺负责人身份证正面照', trigger: 'blur'},
                    ],
                    managerIdentityAccessoryBack: [
                        {required: false, message: '请上传店铺负责人身份证反面照', trigger: 'blur'},
                    ],
                },
                Q_name: [
                    { required: true, message: '请输入服务商名称', trigger: 'blur' },
                ],
                Q_phone: [
                    { required: true,validator: checkPhone, trigger: 'blur' },
                ],
                Q_code: [
                    { required: true, validator: social_Code, trigger: 'blur' },
                ],
                Q_site: [
                    { required: true, message: '请输入服务商地址', trigger: 'blur' },
                ],
                Q_licenseimg: [
                    { required: true, message: '请上传营业执照', trigger: 'blur' },
                ],
                K_site: [
                    { required: true, message: '请输入开户行所在地', trigger: 'blur' },
                ],
                K_name: [
                    { required: true, message: '请输入开户行名称', trigger: 'blur' },
                ],
                bankName: [
                    { required: true, message: '请输入银行名称', trigger: 'blur' },
                ],
                K_number: [
                    // { required: true,validator: bank_Card, trigger: 'blur' },
                    { required: true, message: '请输入对公账号', trigger: 'blur' },
                ],
                F_name: [
                    { required: true, message: '请输入法人姓名', trigger: 'blur' },
                ],
                F_phone: [
                    { required: true,validator: checkPhone, trigger: 'blur' },
                ],
                F_idcard: [
                    { required: true,validator: id_Card, trigger: 'blur' },
                ],
                F_minimg1: [
                    { required: true, message: '请上传法人身份证正面照', trigger: 'blur' },
                ],
                F_minimg2: [
                    { required: true, message: '请上传法人身份证反面照', trigger: 'blur' },
                ],
            },
            loading: true,
        }
    },
    created() {
        this.provinces = provinceCity.options
    },
    mounted () {
        this.getinitialize ()
    },
    methods:{
        handlePictureCardPreview (file,num) {
            switch(num){
                case 1:
                    this.dialogImageUrl1 = file.url;
                    this.dialogVisible1 = true;
                    break
                case 2:
                    this.dialogImageUrl2 = file.url;
                    this.dialogVisible2 = true;
                    break
                case 3:
                    this.dialogImageUrl3 = file.url;
                    this.dialogVisible3 = true;
                    break
                case 4:
                    this.dialogImageUrl4 = file.url;
                    this.dialogVisible4 = true;
                    break
                case 5:
                    this.dialogImageUrl5 = file.url;
                    this.dialogVisible5 = true;
                    break
            }
        },
        // 获取选中的id
        getChooseIds(){
            return this.chooseIds;
        },
        getactive () {
            if(this.checkStatus==1){
                this.active = 2
            }else{
                this.active = 1
            }
        },
        getshowUpt() {
            if(this.checkStatus==1){
                this.showUpt = true
                this.closable = false
            }else{
                this.showUpt = false
                this.closable = true
            }
        },
        //park
        nextStep (){
            this.newparkList = this.$refs.fristStep.getParkList();
            if(!this.newparkList.length){
                this.$showAlert("请至少选择一个园区", "warning")
                return;
            }
            this.getquery(this.newparkList)
            this.showflag = false
        },
        changeProject (parkList) {
            this.newparkList = parkList
            this.chooseIds = [];
            parkList.forEach( it =>{
                this.chooseIds.push(it.id)
            })
        },
        // 获取原来选中的id
        getchecked(list){
            let checked = [];
            for(let i = 0; i < list.length; i++){
                checked.push(list[i].parkId);
            }
            return checked;
        },
        //merchantUpt
        getquery (list) {
            let vm = this;
            let addparkList = [];
            let addshopList = [];
            /* 
                list： 最新选中的数组
                    包括 新增加的、原有的、
                    不包括删除的
                1、先设置chooseIds，
                2、遍历chooseIds和原有表单数据，把原有的先放进去
            */
           let checked = vm.getchecked(vm.ruleForm.parkList);
            list.forEach((item,i)=>{
                if(checked.indexOf(item.id) == -1){ //原来没有选中
                     let park = {
                        parkId: item.id,
                        parkName: item.projectName,
                        serviceType: 3
                    };
                    let shops = {
                        parkId: item.id,
                        businessType: 3,
                        shopName: '',
                        contantMobile:'',
                        managerIdentityNo: '',
                        shopAddress: '',
                        managerIdentityAccessory: '',
                        managerIdentityAccessoryList: [],
                        managerIdentityAccessoryBack:'',
                        managerIdentityAccessoryBackList:[],
                        parkName:item.projectName,
                    };
                    addparkList.push(park)
                    addshopList.push(shops)
                }else if(vm.chooseIds.indexOf(item.id) != -1){// 原来选中了，但是现在也要选中
                    addparkList = addparkList.concat(vm.ruleForm.parkList.filter(park=>park.parkId == item.id));
                    addshopList = addshopList.concat(vm.ruleForm.shopList.filter(shop=>shop.parkId == item.id));
                }
                
            });
            if(vm.editableTabsValue > addparkList.length - 1) {
                vm.editableTabsValue = String(addparkList.length - 1);
            }
            vm.$set(vm.ruleForm, 'parkList', addparkList);
            vm.$set(vm.ruleForm, 'shopList', addshopList);
        },
    // // 省市联动
        handleChange(value) {
            this.ruleForm.K_site = value
        },
    // tab
        handleTabsEdit(targetName, action) {
            if(this.checkStatus!=1){
                this.newAddUserMode = true
            }else{
                this.newAddUserMode = false
            }
            this.targetName = targetName
        },
        btnno () {
            this.newAddUserMode = false
        },
        btnyes () {
            this.ruleForm.shopList.splice(this.targetName,1)
            this.ruleForm.parkList.splice(this.targetName,1)
            this.newparkList.splice(this.targetName,1)
            this.initParkList.splice(this.targetName,1)
            this.initShopList.splice(this.targetName,1)
            this.chooseIds.splice(this.targetName,1)
            this.initChooseId.splice(this.targetName,1)
            this.editableTabsValue = '0'
            this.newAddUserMode = false
            this.getparkIDList ()
        },
    // // 上传
        handleHeadSuccess (res,file, index, num){
            switch(index){
                case 'managerIdentityAccessoryList':
                    this.ruleForm.shopList[num][index].push({ url: this.getimgurl (res.data) })
                    break
                case 'managerIdentityAccessoryBackList':
                    this.ruleForm.shopList[num][index].push({ url: this.getimgurl (res.data) })
                    break
                case 3:
                    this.ruleForm.Q_licenseimg = this.getimgurl (res.data)
                    this.hideUpload3 = true;
                    break
                case 4:
                    this.ruleForm.F_minimg1 = this.getimgurl (res.data)
                    this.hideUpload4 = true;
                    break
                case 5:
                    this.ruleForm.F_minimg2 = this.getimgurl (res.data)
                    this.hideUpload5 = true;
                    break
            }
        },
        getimgurl (data) {
            for (var i in data) {
                var item = new Object();
                item.url = data[i];
                return item.url
            }
        },
        handleHeadRemove(file, fileList,index, num) {
            switch(index){
                case 'managerIdentityAccessoryList':
                   this.ruleForm.shopList[num][index] = [];
                   break
                case 'managerIdentityAccessoryBackList':
                   this.ruleForm.shopList[num][index] = [];
                   break
                case 3:
                   this.hideUpload3 = false;
                   break
                case 4:
                   this.hideUpload4 = false;
                   break
                case 5:
                   this.hideUpload5 = false;
                   break
            }
        },
        beforeAvatarUpload(file) {//上传文件之前的钩子
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            const isLt2M = file.size / 1024 < 500;
            if (!isJPG && !isPNG && !isBMP) {
                this.$showAlert('请正确上传图片!', 'warning');
            }
            if (!isLt2M) {
                this.$showAlert('上传图片大小不能超过 500 kb', 'warning');
            }
            return (isJPG || isPNG || isBMP) && isLt2M;
        },
    // 获取初始数据
        getinitialize () {
            let vm = this;
            vm.loading = true;
            API.http({
                    fullUrl: '/merchant/audit_info',
                    type:'POST',
                }).then(res=>{
                    if(res.code==200){
                        this.checkStatus = res.data.checkStatus
                        this.getshowUpt ()
                        this.getactive ()
                        //商铺
                        for(let key in res.data){
                            if(key == 'parkList'){
                                this.initParkList = [];
                                this.initShopList = [];
                                res.data.parkList.forEach((item, i)=>{
                                    if(item.dataType!=3){
                                        this.chooseIds.push(item.parkId)
                                        this.initChooseId.push(item.parkId);
                                        let park = {
                                            parkId: item.parkId,
                                            parkName: item.parkName,
                                            serviceType: 3
                                        };
                                        vm.$set(vm.ruleForm.parkList, i, park);
                                        vm.$set(vm.initParkList, i, park);
                                        if(item.shopList.length < 1){
                                            let shops = {
                                                parkId: item.parkId,
                                                businessType: 3,
                                                shopName: '',
                                                contantMobile: '',
                                                managerIdentityNo: '',
                                                shopAddress: '',
                                                managerIdentityAccessory: '',
                                                managerIdentityAccessoryList: [],
                                                managerIdentityAccessoryBack: '',
                                                managerIdentityAccessoryBackList: [],
                                                parkName: item.parkName,
                                            }
                                            vm.$set(vm.ruleForm.shopList, i, shops);
                                            vm.$set(vm.initShopList, i, shops);
                                        }
                                        item.shopList.forEach((shopItem)=>{
                                            if(shopItem.businessType==3){
                                                let shops = {
                                                    parkId: shopItem.parkId,
                                                    businessType: 3,
                                                    shopName: shopItem.shopName,
                                                    contantMobile: shopItem.contantMobile,
                                                    managerIdentityNo: shopItem.managerIdentityNo,
                                                    shopAddress: shopItem.shopAddress,
                                                    managerIdentityAccessory: shopItem.managerIdentityAccessory,
                                                    managerIdentityAccessoryList: shopItem.managerIdentityAccessory ? [{url: shopItem.managerIdentityAccessory}] : [],
                                                    managerIdentityAccessoryBack: shopItem.managerIdentityAccessoryBack,
                                                    managerIdentityAccessoryBackList: shopItem.managerIdentityAccessoryBack ? [{url: shopItem.managerIdentityAccessoryBack}] : [],
                                                    parkName:item.parkName,
                                                };
                                                vm.$set(vm.ruleForm.shopList, i, shops);
                                                vm.$set(vm.initShopList, i, shops);
                                            }
                                        })
                                    }
                                })
                            }else{
                                vm.$set(vm.ruleForm, key, res.data[key]);
                            }
                        }
                        //企业
                        this.ruleForm.Q_name = res.data.companyName
                        this.ruleForm.Q_phone = res.data.companyPhone
                        this.ruleForm.Q_code = res.data.businessCardNo
                        this.ruleForm.Q_site = res.data.companyAddress
                        this.ruleForm.Q_licenseimg = res.data.businessCardAccessory
                        if(res.data.businessCardAccessory){
                            this.fileList3.push({ url: res.data.businessCardAccessory});
                            this.hideUpload3 = true
                        }
                        //开户行
                        this.ruleForm.K_site = [res.data.bankProvince,res.data.bankCity]
                        this.ruleForm.K_name = res.data.bankStationName
                        this.ruleForm.K_number = res.data.bankCardNo
                        this.ruleForm.bankName = res.data.bankName
                        //法人
                        this.ruleForm.F_name = res.data.legalName
                        this.ruleForm.F_phone = res.data.legalMobile
                        this.ruleForm.F_idcard = res.data.legalIdentityNo
                        this.ruleForm.F_minimg1 = res.data.legalIdentityAccessory
                        if(res.data.legalIdentityAccessory){
                            this.fileList4.push({ url: res.data.legalIdentityAccessory});
                            this.hideUpload4 = true
                        }
                        this.ruleForm.F_minimg2 = res.data.legalIdentityAccessoryBack
                        if(res.data.legalIdentityAccessoryBack){
                            this.fileList5.push({ url: res.data.legalIdentityAccessoryBack});
                            this.hideUpload5 = true
                        }
                        // 刷新状态
                        access.session('checkStatusC', checkStatus[String(res.data.checkStatus)]);
                        this.$emit('refrashStatus');
                        this.getparkIDList ()
                        // 跳转到第一步
                        vm.$nextTick(()=>{
                            vm.loading = false
                            !vm.isRegister && vm.resetForm();
                        })
                    }
            })
        },
    // // form
        submitForm(callback) {
            // 给图片赋值
            for(let i = 0; i < this.ruleForm.shopList.length; i++){
                this.ruleForm.shopList[i].managerIdentityAccessory = (this.ruleForm.shopList[i].managerIdentityAccessoryList[0] || {}).url || "";
                this.ruleForm.shopList[i].managerIdentityAccessoryBack = (this.ruleForm.shopList[i].managerIdentityAccessoryBackList[0] || {}).url || '';
            }
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    API.http({
                        fullUrl: '/merchant/submit_audit',
                        type:'POST',
                        params:{
                            //开户行
                            bankCardNo:this.ruleForm.K_number,
                            bankProvince:this.ruleForm.K_site[0],
                            bankCity:this.ruleForm.K_site[1],
                            bankStationName:this.ruleForm.K_name,
                            bankCardType:1,
                            bankName:this.ruleForm.bankName,
                            //法人
                            legalName:this.ruleForm.F_name,
                            legalMobile:this.ruleForm.F_phone,
                            legalIdentityNo:this.ruleForm.F_idcard,
                            legalIdentityAccessory:this.ruleForm.F_minimg1,
                            legalIdentityAccessoryBack:this.ruleForm.F_minimg2,
                            //企业
                            companyName:this.ruleForm.Q_name,
                            companyAddress:this.ruleForm.Q_site,
                            companyPhone:this.ruleForm.Q_phone,
                            businessCardNo:this.ruleForm.Q_code,
                            businessCardAccessory:this.ruleForm.Q_licenseimg,
                            //商户
                            shopList:this.ruleForm.shopList,
                            parkList:this.ruleForm.parkList,
                        }
                }).then(res=>{
                    if(res.code==200){
                        this.active = 2
                        this.$notify.success({title: '操作成功'});
                        this.showUpt = true
                        this.closable = false
                        if(isFunction(callback)) callback();
                        access.session('checkStatus',1)
                        access.session('checkStatusC', '待审核');
                        this.checkStatus = access.session('checkStatus'); //审核状态
                        this.$emit('refrashStatus');
                    }else{
                        this.$notify.warning({title: res.message});
                    }
                })
                } else {
                        this.$notify.warning({title: "请把信息填写完整"});
                return false;
                }
            });
        },
        getparkIDList () {
            let list = []
            this.ruleForm.shopList.forEach((item)=>{
                list.push(item.parkId)
            })
            this.chooseIds = list
        },
        resetForm() {
            this.showflag = true
        },
        gopark () {
            if(this.isRegister) {
                this.$emit('goPark');
                return;
            }
            this.showflag = true
        },
        addpicture (url) {
            if(!url) return
            this.src = url
            this.showpicture = true
        },
        xiaoshi () {
            this.showpicture = false
        },
    }
}
</script>

<style lang="scss" scoped>
    .box{
        .showspan{
            // display: inline-block;
            // height: 40px;
            // line-height: 20px;
            // margin-top:5px;
        }
        .park{
            .footer{
                width:calc(100% - 220px);
                position: fixed;
                bottom:0;
                background-color: #fff;
                margin-left: -20px;
                height: 60px;
                line-height: 60px;
                text-align: center;
            }
        }
        .merchantUpt{
            .orderStep {
                background-color: #fff;
                border-radius: 4px;
                margin-bottom:20px;
            .box-content{
                padding: 60px 0;
                text-align: center;
            }
            .box-item{
                position: relative;
                display: inline-block;
                width: 200px;
                font-size: 14px;
                color: #ACB9CB;
                .flag{
                    position: absolute;
                    width: 60px;
                    height: 1px;
                    background-color: #DFE5EC;
                    top:16px;
                    
                }
                .flag-left{
                    top:16px;
                }
                .flag-right{
                    right: 0;
                }
                .center-box{
                    &.has{
                        .step-index{
                            display: none;
                        }
                        .el-icon-check{
                            display: inline-block;
                            font-size: 15px;
                            color: #fff;
                            background-color: #8CD9C9;
                        }
                        .step-text{
                            color: #8CD9C9;
                        }
                    }
                    &.current{
                        .step-num{
                            color: white;
                            background-color: #1AB394;
                        }
                        .step-text{
                            color: #1AB394;
                        }
                    }
                    .step-num{
                        width: 32px;
                        height: 32px;
                        margin: 0 auto;
                        line-height: 32px;
                        color: #ACB9CB;
                        border-radius: 50%;
                        background-color: #F2F5FA;
                    }
                    .el-icon-check{
                        display: none;
                    }
                    text-align: center;
                }
            }
        }
            .title{
                color: #1AB394;
                font-size: 16px;
                font-weight:600;
                margin-bottom: 11px;
            }
            .picture{
                position: relative;
                width: 100px;
                height: 100px;
                border: 1px solid #C2C8CC;
                border-radius: 8px;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 8px;
                }
                .zzc{
                    position: absolute;
                    width: 100px;
                    height: 100px;
                    background:url(../../../assets/img/icon/fdj.png) no-repeat center;
                    background-color: rgba(0,0,0,.5);
                    opacity: 0;
                    border-radius: 8px;
                    top:50;
                    left:0;
                    cursor:pointer;
                }
                .zzc:hover{
                    opacity: 1;
                    transition:0.3s;
                }
            }
            .bigpicture{
                width: 100%;
                height: 100%;
                position:fixed;
                top:0;
                left:0;
                display: flex;
                align-items: center;
                justify-content: center;
            .picturebox{
                width: 600px;
                height: 400px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
            .footer{
                width:calc(100% - 220px);
                position: fixed;
                bottom:0;
                background-color: #fff;
                margin-left: -20px;
                height: 60px;
                line-height: 60px;
                text-align: center;
            }
            .tabbox{
                position: relative;
            }
            #addicon{
                width: 20px;
                height: 20px;
                position: absolute;
                top:15px;
                right:20px;
                cursor:pointer;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .newRow{
                margin-top:15px;
                display: flex;
                flex-wrap: wrap;
                .newCol{
                    float: none;
                }
            }
        }
    }
</style>
<style lang="scss">
    .box{
        .merchantUpt{
            // .el-col-12{
            //     height: 70px;
            // }
            .tabs.el-tabs .el-tabs__header{
                padding-right: 60px;
            }
            .el-tabs__nav-next, .el-tabs__nav-prev{
                line-height: 53px;
            }
            .el-upload-list__item{
                transition: none;
            }
            .el-upload--picture-card {
                    background-color: #fbfdff;
                    border:1px dashed #c0ccda;
                    border-radius:6px;
                    box-sizing:border-box;
                    width:100px;
                    height:100px;
                    line-height:98px;
                    vertical-align: top;
                }
                .el-upload-list--picture-card .el-upload-list__item {
                    overflow: hidden;
                    background-color: #fff;
                    border: 1px solid #c0ccda;
                    border-radius: 6px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    width: 100px;
                    height: 100px;
                    margin: 0 8px 8px 0;
                    display: inline-block;
                }
                .hideUpload1 .el-upload--picture-card{
                    display: none;
                }
                .hideUpload2 .el-upload--picture-card{
                    display: none;
                }
                .hideUpload3 .el-upload--picture-card{
                    display: none;
                }
                .hideUpload4 .el-upload--picture-card{
                    display: none;
                }
                .hideUpload5 .el-upload--picture-card{
                    display: none;
                }
                
        }
    }
</style>

